/* src/AuthenticatedRoute.js */
import React, { useContext, useEffect, useState } from "react";
import AppContext from "./AppContext";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { signIn, signOut, getCurrentUser } from "aws-amplify/auth";

function AuthenticatedRoute(props) {
  const [globalState, setGlobalState, q, p] = useContext(AppContext);
  const [localState, setLocalState] = useState({ passthrough: true });
  // const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    getCurrentUser().catch(() => {
      navigate("/signin");
    });
  }, [globalState?.loggedIn]);

  useEffect(() => {
    if (p.onboarded === false || localState.passthrough === false) {
      localStorage.clear();
      (async () => {
        return await signOut();
      })();
    }
  }, [p.onboarded, localState.passthrough]);

  try {
    if (localStorage.length > 0 || p.onboarded === true) {
      return <Outlet globalState={globalState} />;
    } 
    else if (p.onboarded === false && p.loggedIn === true) {
      return <Navigate to="/signin" />;
    } 
    else {
      return <Navigate to="/signin" />;
    }
  } catch (e) {
    localStorage.clear();
    p.onboarded = false;
    setLocalState({ passthrough: false });
    return <Navigate to="/signin" />;
  }
}
export default AuthenticatedRoute;
